import { useParams } from "react-router-dom";
import { Loader2, MessageCircle } from "lucide-react";
import { BoyShell } from "@/components/boy/BoyShell";
import { BoyLiveView, useBoyTrack } from "@/components/boy/BoyLive";
import { RoutePoints } from "@/components/boy/RideStatus";
import { waLink } from "@/lib/api";
import { RIDE_STATUS } from "@/lib/boy";

export default function BoyTrack() {
  const { token } = useParams();
  const [d, err] = useBoyTrack(token);
  if (err && !d) return <BoyShell><p className="card-surface p-6 text-center text-sm text-muted-foreground" data-testid="boy-track-error">{err}</p></BoyShell>;
  if (!d) return <BoyShell><p className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin" /></p></BoyShell>;
  return (
    <BoyShell info={{ store: d.merchant }}>
      <div className="card-surface space-y-4 p-5" data-testid="boy-track-card">
        <div className="flex items-center justify-between gap-2">
          <p className="text-xl font-bold">Acompanhe seu pedido</p>
          <span className="rounded-full bg-muted px-2.5 py-0.5 text-xs font-semibold" data-testid="boy-track-status">{RIDE_STATUS[d.status]}</span>
        </div>
        <BoyLiveView d={d} />
        <RoutePoints from={d.origin.label} to={d.dest.label} />
        {d.merchant_whatsapp && (
          <a href={waLink(d.merchant_whatsapp, `Olá! Estou acompanhando meu pedido (corrida #${d.number}).`)} target="_blank" rel="noreferrer"
            className="flex items-center justify-center gap-2 rounded-lg border p-3 text-sm font-semibold text-emerald-600 transition-colors hover:bg-emerald-500/10" data-testid="boy-track-store-wa">
            <MessageCircle className="h-4 w-4" />Falar com a {d.merchant} no WhatsApp
          </a>
        )}
      </div>
    </BoyShell>
  );
}
